import config from '../utils/config';
import request from '../utils/request';

const {api} = config;
const { notifyHistory, notifyLogs, notifyLogDetails, notifyLogDetailsRecipients ,notifyHistoryTemplate,refundTimer,notifyLogPushTest} = api;

export async function findNotifyHistory(params) {
    return request({url: notifyHistory, method: 'get', data: params})
}

export async function saveNotifyHistory(params) {
    return request({url: notifyHistory, method: 'post', data: params})
}

export async function findNotifyHistoryTemplate(params) {
    return request({url: notifyHistoryTemplate, method: 'post', data: params})
}

export async function findLogs(params) {
    return request({url: notifyLogs, method: 'get', data: params})
}

export async function findLogDetails(params) {
    return request({url: notifyLogDetails, method: 'get', data: params})
}
export async function findLogDetailsRecipients(params) {
    return request({url: notifyLogDetailsRecipients, method: 'get', data: params})
}
export async function cancelRefundTimer(params) {
    return request({url: refundTimer, method: 'post', data: params})
}
export async function findNotifyLogPushTest(params) {
    return request({url: notifyLogPushTest, method: 'post', data: params})
}


// WEBPACK FOOTER //
// ./src/services/notifyHistory.js